module.exports = __webpack_public_path__ + "static/media/no-leafs.f91cb9eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/no-leafs.svg
// module id = 384
// module chunks = 21